import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-button-renderer',
  template: `
    <button type="button" class="define-button-table" (click)="onClick($event)">{{label}}</button>
  `,
  styles: [`
    .define-button-table {
      font-family: "Source Sans Pro Web,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif" !important;
      background-color: rgb(177, 17, 22);
      color: #fff;
      font-weight: 700;
      border-radius: 0.25rem;
      text-decoration: none;
      border: none;
      margin: 0.3rem auto !important;
      display: block;
      cursor: pointer;
      padding: 0.5rem;
    }
  `]
})

export class ButtonChargeCodeRendererComponent implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.onClick(params);
    }
  }
}
